import { Chip, ChipProps } from "@mui/material";
import React from "react";

interface IStatusButton extends ChipProps {
  status: "Pending" | "Approved" | "Completed";
}

const StatusButton = ({ status, ...props }: IStatusButton) => {
  return (
    <Chip
      label={status}
      color={status === "Pending" ? "error" : status === "Completed" ? "success" : "warning"}
      sx={{ minWidth: "100px", borderRadius: "5px" }}
      {...props}
    />
  );
};

export default StatusButton;
